import { motion } from "framer-motion";
import Pill from "core/components/Pill";
import Typography from "core/components/Typography";
import { ROLES, TABLEAU_ROLES, ANALYTICS_HUB_USER_ROLES } from "core/constants";
import {
  MembershipsList,
  MemberItem,
  MemberHeader,
  MemberRolesList,
  RoleItem,
} from "modules/admin/styles";
import useCurrentUser from "core/hooks/useCurrentUser";
import useActiveMembership from "core/hooks/useActiveMembership";

const UserProfileMembershipsPage = () => {
  const { currentUser } = useCurrentUser();
  const { activeMembership } = useActiveMembership();

  return (
    <motion.div>
      <Typography variant="h2">Memberships</Typography>
      <div style={{ maxWidth: "600px" }}>
        <Typography
          variant="p"
          noMargin
          color="var(--color-base-content)"
          style={{ lineHeight: "22px", marginBottom: "24px" }}
        >
          You are a member of the following organizations. You can only be a
          member of an organization by invitation from an admin.
        </Typography>
        <MembershipsList>
          {currentUser.memberships.map((membership) => {
            return (
              <MemberItem key={membership.organization_id}>
                <MemberHeader>
                  <Typography
                    variant="h5"
                    noMargin
                    className="organization-name"
                  >
                    {membership.organization_name}
                  </Typography>
                  <div style={{ height: "30px" }}>
                    {membership.organization_id === activeMembership.id && (
                      <Pill text="Current" size="large" variant="success" />
                    )}
                  </div>
                </MemberHeader>

                <MemberRolesList>
                  <RoleItem>
                    <div>Role:</div>
                    <div>{ROLES[membership.role]} </div>
                  </RoleItem>

                  <RoleItem>
                    <div>Analytics Hub User:</div>
                    <div>
                      {ANALYTICS_HUB_USER_ROLES[
                        membership.analytics_hub_access
                      ] || "None"}{" "}
                    </div>
                  </RoleItem>

                  <RoleItem>
                    <div>BI Portal User: </div>
                    <div>
                      {TABLEAU_ROLES[membership.tableau_config.license] ||
                        "None"}
                    </div>
                  </RoleItem>
                </MemberRolesList>
              </MemberItem>
            );
          })}
        </MembershipsList>
      </div>
    </motion.div>
  );
};

export default UserProfileMembershipsPage;
